import { ContainedButton } from "@/common";
import { Box } from "@mui/material";
import styled from "styled-components";
import { tokens } from "@/tokens";

export const StyledContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const StyledContainedButton = styled(ContainedButton)({
  borderColor: tokens.border.default,
  fontWeight: tokens.fontWeight.semibold,
  "& .MuiButton-startIcon": {
    marginRight: "4px",
  },
});
